

<div *ngIf="message" [ngClass]="{'showoverlay': (message) }"  id="overlay" >
  <div id="text">
      <div id="overlayheader">
          <i class="fa fa-close ml-1 mr-1" style="font-size: x-large; line-height: 30px;"></i> {{'confirmtilte'|translate}}
      </div>

  <div id="overlaybody">
      <i class="fas fa-trash-alt fa-3x font-weight-light"></i>
      <div class=" border border-danger mb-2 ml-3 mr-3" style="width: 2px;height: 45px;"></div>
      <div id="textcontainer" >
        <h4>{{'confirmsgbody'|translate}}</h4>
      </div>
   </div>
  <div class="w-100 border-top border-secondary d-flex flex-row-reverse p-1 bg-white30 " >

    <button class="btn btn-danger  m-1" (click)="message.yesFn()">
      <i class="fas fa-check" aria-hidden="true"></i>
      {{'Confirmedok'|translate}}
    </button>
    <button class="btn btn-secondary m-1" (click)="message.noFn()">
      <i class="fa fa-close" aria-hidden="true"></i>
      {{'Confirmedcancel'|translate}}
    </button>
  </div>
  </div>
</div>
